import { createContext } from 'react';
import { DateRange } from '@robocorp/components';
import { TimeRangeValues } from '~/constants/timeRanges';

interface TimeRangeSettingsContext {
  preset: TimeRangeValues;
  range: DateRange | undefined;
  timestamp: Date;
  onPresetChange: (value: TimeRangeValues, customRange?: DateRange) => void;
  withBillingPreset: boolean;
  isLoading: boolean;
  timezone: string;
}

export const TimeRangeContext = createContext<TimeRangeSettingsContext>({
  preset: TimeRangeValues.THIS_MONTH,
  range: undefined,
  timestamp: new Date(),
  onPresetChange: () => null,
  withBillingPreset: false,
  isLoading: false,
  timezone: 'local',
});
